import { useTranslation } from "react-i18next";
import { applyLocaleToDocument, type SupportedLocale } from "../../i18n";
import { supabase } from "../../lib/supabase";

export function LanguageSwitcher({ persistForEmployeeId }: { persistForEmployeeId?: string }) {
  const { t, i18n } = useTranslation();
  const locale: SupportedLocale = i18n.resolvedLanguage === "en" ? "en" : "ar";

  const switchLocale = async () => {
    const nextLocale: SupportedLocale = locale === "ar" ? "en" : "ar";
    await i18n.changeLanguage(nextLocale);
    applyLocaleToDocument(nextLocale);
    if (persistForEmployeeId) {
      await supabase
        .from("user_preferences")
        .update({ locale: nextLocale })
        .eq("employee_id", persistForEmployeeId);
    }
  };

  return (
    <button className="language-button" onClick={() => void switchLocale()} type="button">
      {locale === "ar" ? t("actions.switchToEnglish") : t("actions.switchToArabic")}
    </button>
  );
}
